/**
 * Based on index, slide to item.
 * Consists of horizontally sliding to that display item of that index
 * and setting navigation item of that index to active.
 *
 * Beside index, the other parameters match those as defined in slider function.
 *
 * @param {*} index index of item to slide to
 * @param {*} $slider wrapper of the slider; element with js-slider class
 * @param {*} $navigationitems result of `.slider-navigation .slider-item` on $slider
 * @param {*} $display result of `.slider-display` on $slider
 * @param {*} $displayitems result of `.slider-display .slider-item` on $slider
 * @returns
 */
const slideTo = function(index, $slider, $navigationitems, $display, $displayitems) {
  if (index < 0) return;

  // Unset previous active state
  $navigationitems.forEach($el => $el.classList.remove('is-active'));
  // Set current active state
  $navigationitems[index].classList.add('is-active');

  // Horizontally scroll to the item in $display
  // $slider.offsetLeft is used because the element may or may not (mobile vs tablet) be out of bounds
  // and this way the new left is aligned with the container padding
  $display.scroll({
    top: 0,
    left: $displayitems[index].offsetLeft - $slider.offsetLeft,
    behavior: 'smooth'
  });
};

/**
 * Hydrate slider on wrapper with js-slider class.
 * If any of the expected elements don't exist, don't continue.
 * Initialize by setting first item to active.
 * On click of navigation items and display items, set that item to active.
 */
const slider = function() {
  const $sliders = document.querySelectorAll('.js-slider');
  $sliders.forEach($slider => {
    const $display = $slider.querySelector('.slider-display');
    const $navigationitems = $slider.querySelectorAll('.slider-navigation .slider-item');
    const $displayitems = $slider.querySelectorAll('.slider-display .slider-item');

    if ($navigationitems.length === 0 || $displayitems.length === 0) return;

    // Set initial active state
    $navigationitems[0].classList.add('is-active');

    // Clicking allowed on either display item (image) or navigation item (button)
    [...$displayitems, ...$navigationitems].forEach($item => {
      $item.addEventListener('click', () => {
        const navindex = [...$navigationitems].indexOf($item);
        const displayindex = [...$displayitems].indexOf($item);
        if (navindex > -1 || displayindex > -1) {
          slideTo(
            navindex > -1 ? navindex : displayindex,
            $slider,
            $navigationitems,
            $display,
            $displayitems
          );
        }
      });
    });
  });
};

module.exports = slider;
